import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { BaseRestService } from "./base-rest.service";

@Injectable({
  providedIn: 'root'
})
export class CurrencyService extends BaseRestService {

  readonly API_URL: string = environment.apiUri + '/currency';

  getList(pageParams: any): Observable<any> {
    const options = {
      headers: this.headers,
      params: this.removeEmptyPropertyFromObject(pageParams)
    }
    return this.httpClient.get(this.API_URL + '/list', options);
  }

  getById(id: string): Observable<any> {
    return this.httpClient.get(this.API_URL + "/" + id,
      { headers: this.headers });
  }

  getRateHistory(pageParams: any): Observable<any> {
    const options = {
      headers: this.headers,
      params: this.removeEmptyPropertyFromObject(pageParams)
    }
    return this.httpClient.get(this.API_URL + "/rate/history", options);
  }

  create(data): Observable<any> {
    return this.httpClient.post(this.API_URL, JSON.stringify(data),
      { headers: this.headers });
  }

  enable(id: string): Observable<any> {
    return this.httpClient.put(this.API_URL + "/" + id + "/enable",
      { headers: this.headers });
  }

  disable(id: string): Observable<any> {
    return this.httpClient.put(this.API_URL + "/" + id + "/disable",
      { headers: this.headers });
  }

  update(id: string, data): Observable<any> {
    return this.httpClient.put(this.API_URL + "/" + id, JSON.stringify(data),
      { headers: this.headers });
  }

}
